import React, { useEffect, useState } from 'react';
import { useAuth } from '../../context/AuthProvider';
import { useNavigate } from 'react-router-dom';
import { Box, Typography, Button, CssBaseline } from '@mui/material';
import { createTheme, ThemeProvider } from '@mui/material/styles';

const TokenExpiryModal = () => {
  const { isAuthenticated, isTokenExpired, setIsTokenExpired, logout } = useAuth();
  const navigate = useNavigate();
  const [showModal, setShowModal] = useState(false);

  useEffect(() => {
    if (isTokenExpired) {
      setShowModal(true);
    }
  }, [isTokenExpired]);

  // Define dark and light themes for the modal
  const darkTheme = createTheme({
    palette: {
      mode: 'dark',
      background: {
        paper: '#424242',
      },
      primary: {
        main: '#90caf9',
      },
      text: {
        primary: '#ffffff',
      },
    },
  });

  const lightTheme = createTheme({
    palette: {
      mode: 'light',
      background: {
        paper: '#ffffff',
      },
      primary: {
        main: '#1976d2',
      },
      text: {
        primary: '#000000',
      },
    },
  });

  // Use light theme if logged in, otherwise dark theme
  const appliedTheme = isAuthenticated ? lightTheme : darkTheme;

  const handleOk = () => {
    setShowModal(false);
    setIsTokenExpired(false);
    logout();
    navigate('/login', { replace: true });
  };

  if (!showModal) return null;

  return (
    <ThemeProvider theme={appliedTheme}>
      <CssBaseline />
      <Box
        sx={{
          position: 'fixed',
          top: 0,
          left: 0,
          width: '100vw',
          height: '100vh',
          bgcolor: 'rgba(0,0,0,0.5)',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          zIndex: 1000,
        }}
      >
        <Box
          sx={{
            bgcolor: 'background.paper',
            p: 3,
            borderRadius: 2,
            textAlign: 'center',
            maxWidth: 400,
            boxShadow: 3,
          }}
        >
          <Typography variant="h5" gutterBottom>
            Session Expired
          </Typography>
          <Typography variant="body1">
            Your session has expired. Please log in again.
          </Typography>
          <Button
            variant="contained"
            color="primary"
            onClick={handleOk}
            sx={{ mt: 2 }}
          >
            Login Again
          </Button>
        </Box>
      </Box>
    </ThemeProvider>
  );
};

export default TokenExpiryModal;
